import isServer from './isServer';

function generateBaseUrl(path: string, name?: string, ignoreRoot = false): string {
  const url = `/api/${path.replace(/^\//, '')}${name ? `/${name}` : ''}`;

  if (isServer() && !ignoreRoot) {
    if (process.env.HTTPS_MODE) {
      return `https://local.picsart.com${url}`;
    }
    return `http://localhost:8080${url}`;
  }

  return url;
}

export default function endpointConstructor<P>(
  path: string,
  name?: string,
  params?: P,
  ignoreRoot?: boolean,
  isSearch = false,
): string {
  const BASE_API_URL = isSearch
    ? `${process.env.NEXT_PUBLIC_API_URL}/${path}/${name}`
    : generateBaseUrl(path, name, ignoreRoot);

  const _params = params ? Object.entries(params) : [];

  return _params.length
    ? _params.reduce(
        (acc, [key, value], idx) => (!idx ? `${acc}?${key}=${value}` : `${acc}&${key}=${value}`),
        BASE_API_URL,
      )
    : BASE_API_URL;
}
